<template>
  <div class="cloudBox">
    <div class="cloudBox_head">
      <div class="cloudBox_head_tit">应用场景</div>
      <div class="cloudBox_head_cen">
        <div @click="switchFun('scene', data3)">
          <div class="head_cen_img">
            <img src="../../assets/printing/img2.png" alt="/">
          </div>
          <div class="head_cen_tit">自助打印</div>
          <div style="font-size:16px;opacity:0.6;">适用于高校、政务大厅、图书馆等场景</div>
          <hr>
          <!-- <div class="head_cen_foot">*用户打印、复印、扫描均不用付费。</div> -->
          <div class="head_cen_foot">*打印、复印、扫描都是要微信付款才出纸。</div>
        </div>
        <div @click="switchFun('scene', data2)">
          <div class="head_cen_img">
            <img src="../../assets/printing/img1.png" alt="/">
          </div>
          <div class="head_cen_tit">共享办公</div>
          <div style="font-size:16px;opacity:0.6;">适用于众创空间、保险、培训机构等场景</div>
          <hr>
          <div class="head_cen_foot">*分为用户付费和企业付费。</div>
          <div class="head_cen_foot">*用户付费：打印复印扫描等付款出纸</div>
          <div class="head_cen_foot">*企业付费：打印复印扫描不用用户付钱，从企业帐户扣除余额。</div>
        </div>
        <div @click="switchFun('scene', data1)">
          <div class="head_cen_img">
            <img src="../../assets/printing/img10.png" alt="/">
          </div>
          <div class="head_cen_tit">企业办公</div>
          <div style="font-size:16px;opacity:0.6;">适用于企业办公场景</div>
          <hr>
          <div class="head_cen_foot">*用户打印、复印、扫描均不用付费。</div>
          <div class="head_cen_foot">*用户操作后企业管理平台产生记录可查看用户统计报表。</div>
        </div>

      </div>
    </div>
    <div class="cloudBox_foot" v-if="hasIssueData">
      <div class="cloudBox_foot_tit">常见问题</div>
      <div class="cloudBox_foot_cen">
        <div v-for="(item, index) of issueWithData" :key="index">
          <div class="foot_cen_img">
            <img v-if="item.name === '企业办公'" src="../../assets/printing/img10.png" alt="/">
            <img v-else-if="item.name === '共享办公'" src="../../assets/printing/img1.png" alt="/">
            <img v-else src="../../assets/printing/img2.png" alt="/">
            <span>{{ item.name }}</span>
          </div>
          <div v-for="(item2, index2) of item.data" :key="index2" class="foot_cen_ps">
            <span @click="switchFun('issueSolving', item, index2)">{{ item2.name }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mixin from "./mixin"
export default {
  mixins: [mixin],
  data() {
    return {
      data1: [],//企业办公
      data2: [],//共享办公
      data3: [],//快印自助
      issue: [],//问题列表
    }
  },
  computed: {
    // 只保留 data 有数据的项，避免 v-for 与 v-if 同用
    issueWithData() {
      return this.issue.filter(item => item && item.data && item.data.length > 0)
    },
    // 是否有任意一个 issue 的 data 有数据
    hasIssueData() {
      return this.issueWithData.length > 0
    }
  },
  methods: {
    getIssueFun() {
      axios
        .all([
          axios.get(`/ProductSystem/Issue/TreeList?id=1`),
          axios.get(`/ProductSystem/Issue/TreeList?id=2`),
          axios.get(`/ProductSystem/Issue/TreeList?id=3`)
        ])
        .then(res => {
          this.addOrderLoading = false
          console.log(res)
          if (res[0].isSuccess && res[1].isSuccess && res[2].isSuccess) {
            this.data1 = {
              name: "企业办公",
              data: JSON.parse(res[0].data)
            }
            this.data2 = {
              name: "共享办公",
              data: JSON.parse(res[1].data)
            }
            this.data3 = {
              name: "快印自助",
              data: JSON.parse(res[2].data)
            }
            this.issue.push(JSON.parse(res[2].data).filter(item => { return item.type == 3 })[0])
            this.issue[0].name = "自助打印"

            this.issue.push(JSON.parse(res[1].data).filter(item => { return item.type == 3 })[0])
            this.issue[1].name = "共享办公"

            this.issue.push(JSON.parse(res[0].data).filter(item => { return item.type == 3 })[0])
            this.issue[2].name = "企业办公"
          } else {
            this.$message({
              message: "获取数据异常!",
              type: "error"
            });
          }
        })
    },
    extractIssueFun(arr) {

    }
  },
  created() {
    window.scrollTo(0, 0);
    this.getIssueFun()
  }
}
</script>

<style scoped>
.cloudBox {
  color: #18182a;
  font-size: 18px;
}

.cloudBox_head {
  padding: 90px 0 110px;
  background: #f4f7fd;
}

.cloudBox_head_tit,
.cloudBox_foot_tit {
  line-height: 37px;
  font-size: 40px;
  text-align: center;
  margin-bottom: 60px;
}

.cloudBox_head_cen,
.cloudBox_foot_cen {
  max-width: 1186px;
  min-width: 375px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin: auto;
}

.cloudBox_head_cen hr {
  width: 225px;
}

.cloudBox_head_cen>div {
  width: 360px;
  height: 360px;
  text-align: center;
  background: #ffffff;
  padding: 40px 36px 30px;
  font-size: 14px;
  margin-bottom: 20px;
}

.cloudBox_head_cen>div:hover {
  cursor: pointer;
}

.head_cen_img img {
  width: 87px;
  height: 78px;
}

.head_cen_tit {
  font-size: 20px;
  font-weight: 700;
  line-height: 63px;
}

.head_cen_foot {
  opacity: 0.6;
  padding: 0 14px 0;
}

.cloudBox_foot {
  padding: 90px 0 110px;
}

.cloudBox_foot_cen>div {
  width: 225px;
  margin-bottom: 20px;
}

.foot_cen_img {
  margin-bottom: 10px;
}

.foot_cen_img img {
  width: 32px;
  height: 28px;
  margin-right: 13px;
  vertical-align: middle;
}

.foot_cen_img span {
  font-size: 22px;
  font-weight: 700;
  line-height: 28px;
  vertical-align: middle;
}

.foot_cen_ps {
  width: 225px;
  border-bottom: 1px solid #ebeef5;
  line-height: 50px;
  color: #555555;
}

.foot_cen_ps span:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/comm/cloudBox.vue